module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-311.c91c7b9.woff2";